<ngx-zero-state>
	<p zero-state-title>{{getTitle() | async}}</p>
	<p zero-state-subtext>{{getSubText() | async}}</p>
	<div zero-state-body *ngIf="showButtons()">
		<button class="secondary-btn" *ngIf="canInvite" (click)="openInvite.emit()">{{'common_invite' | translate}}</button>
		<button (click)="createFolder.emit()" data-cy="create-course" class="primary-btn">{{'folders_view-create_button' | translate}}</button>
	</div>
	<div zero-state-graphic-bottom *ngIf="showGraphic()">
		<img src="https://staticassets.goreact.com/astronaut-astroid.svg" alt="No Results">
	</div>
</ngx-zero-state>
